import isPropValid from '@emotion/is-prop-valid';
import { isString } from 'lodash';

// styled-components 6 passes every prop to a DOM element; forward only the valid HTML attributes, as v5 did.
export const shouldForwardProp = (propName: string, target: unknown): boolean =>
  isString(target) ? isPropValid(propName) : true;
